/* Oùmami : panier (tiroir oum-panier et page oum-panier-page, même contenu : snippet oum-panier-contenu).
   - oum.ajouterAuPanier(lignes | FormData) : ajoute, rafraîchit les paniers affichés et ouvre le tiroir.
   - Quantité (+ / - / saisie) et retrait d'une ligne : /cart/change.js ; chaque zone [data-oum-panier-zone] est rendue à
     nouveau par sa section (Section Rendering API), donc tiroir et page restent identiques.
   - Date de livraison estimée calculée dans le navigateur (heure de Paris) : jamais figée par le cache. */
(() => {
  const oum = (window.oum = window.oum || {});
  if (oum.panierCharge) return;
  oum.panierCharge = true;

  const tiroir = () => document.getElementById('oum-panier');
  const zones = () => [...document.querySelectorAll('[data-oum-panier-zone][data-section]')];
  const racine = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function remplacer(sections) {
    zones().forEach((z) => {
      const html = sections[z.dataset.section];
      if (!html) return;
      const neuf = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-oum-panier-contenu]');
      const actuel = z.querySelector('[data-oum-panier-contenu]');
      if (neuf && actuel) actuel.innerHTML = neuf.innerHTML;
    });
    dateLivraison();
  }

  function annoncer(panier) {
    document.dispatchEvent(new CustomEvent('oum:panier', { detail: panier }));
  }

  async function requete(chemin, corps) {
    const zs = zones();
    const sections = zs.map((z) => z.dataset.section).join(',');
    zs.forEach((z) => z.setAttribute('aria-busy', 'true'));
    try {
      const options = { method: 'POST', headers: { Accept: 'application/json' } };
      if (corps instanceof FormData) {
        if (sections) corps.append('sections', sections);
        options.body = corps;
      } else {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify({ ...corps, ...(sections ? { sections } : {}) });
      }
      const rep = await fetch(racine() + chemin, options);
      const donnees = await rep.json();
      if (!rep.ok) throw donnees;
      if (donnees.sections) remplacer(donnees.sections);
      const panier = await (await fetch(racine() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      annoncer(panier);
      return donnees;
    } finally {
      zs.forEach((z) => z.removeAttribute('aria-busy'));
    }
  }

  oum.ajouterAuPanier = async (contenu) => {
    const corps = contenu instanceof FormData ? contenu : { items: contenu };
    const r = await requete('cart/add.js', corps);
    if (tiroir()) oum.ouvrirPanneau('oum-panier');
    else window.location.href = racine() + 'cart';
    return r;
  };

  oum.changerLigne = (cle, quantite) => requete('cart/change.js', { id: cle, quantity: Math.max(0, quantite) });

  document.addEventListener('click', (ev) => {
    const ligne = ev.target.closest('[data-oum-panier-zone] .oum-panier__ligne');
    if (!ligne) return;
    const bouton = ev.target.closest('[data-oum-quantite], [data-oum-retirer]');
    if (!bouton) return;
    ev.preventDefault();
    const champ = ligne.querySelector('.oum-panier__quantite-champ');
    const actuelle = parseInt(champ.value, 10) || 0;
    const quantite = bouton.hasAttribute('data-oum-retirer') ? 0 : actuelle + parseInt(bouton.dataset.oumQuantite, 10);
    champ.value = Math.max(0, quantite);
    oum.changerLigne(ligne.dataset.cle, quantite);
  });

  document.addEventListener('change', (ev) => {
    const champ = ev.target.closest('[data-oum-panier-zone] .oum-panier__quantite-champ');
    if (!champ) return;
    oum.changerLigne(champ.closest('.oum-panier__ligne').dataset.cle, parseInt(champ.value, 10) || 0);
  });

  /* Préférences de cookies (lien « # » du pied de page) : bannière native de Shopify */
  document.addEventListener('click', (ev) => {
    if (!ev.target.closest('[data-oum-cookies]')) return;
    ev.preventDefault();
    if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
  });

  /* Date de livraison estimée : expédition le jour même avant l'heure limite (lundi à jeudi), vendredi après l'heure
     limite = lundi, samedi = lundi, dimanche = lundi ; puis N jours ouvrés de transport. Reprend le calcul du site. */
  const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const MOIS = ['janv.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  function maintenantParis() {
    const p = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false }).formatToParts(new Date());
    const v = (t) => parseInt(p.find((x) => x.type === t).value, 10);
    return { date: new Date(Date.UTC(v('year'), v('month') - 1, v('day'))), heure: v('hour') % 24 };
  }
  function dateLivraison() {
    document.querySelectorAll('[data-oum-livraison]').forEach((el) => {
      const limite = parseInt(el.dataset.heureLimite || '15', 10);
      const transport = parseInt(el.dataset.jours || '2', 10);
      const { date, heure } = maintenantParis();
      const jour = date.getUTCDay();
      let delai = 0;
      if (jour >= 1 && jour <= 4) delai = heure >= limite ? 1 : 0;
      else if (jour === 5) delai = heure >= limite ? 3 : 0;
      else if (jour === 6) delai = 2;
      else delai = 1;
      let total = delai;
      let reste = transport;
      let d = new Date(date);
      for (let i = 0; i < 20 && reste > 0; i++) {
        d = new Date(d.getTime() + 86400000);
        const j = d.getUTCDay();
        if (j >= 1 && j <= 5) reste -= 1;
        total += 1;
      }
      const livraison = new Date(date.getTime() + total * 86400000);
      el.textContent = `${JOURS[livraison.getUTCDay()]} ${livraison.getUTCDate()} ${MOIS[livraison.getUTCMonth()]}`;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dateLivraison);
  else dateLivraison();
})();
